/**
 * Backoff exponencial com jitter para a reconexão STOMP (R2CLOUD-1098).
 *
 * A base dobra a cada falha consecutiva e estabiliza em MAX_RECONNECT_DELAY_MS.
 * O jitter é aplicado somente no agendamento (não na base acumulada), para a
 * progressão ser determinística e o espalhamento acontecer a cada tentativa.
 *
 * Funções puras, sem dependência de Angular — testadas em test/stomp-backoff.test.ts.
 */
export const INITIAL_RECONNECT_DELAY_MS = 1000;
export const MAX_RECONNECT_DELAY_MS = 60000;

export function nextReconnectDelay(currentDelay: number): number {
    if (currentDelay <= 0) {
        return INITIAL_RECONNECT_DELAY_MS;
    }
    return Math.min(currentDelay * 2, MAX_RECONNECT_DELAY_MS);
}

/**
 * Espalha o delay no intervalo [0,5×, 1,5×) da base, para clientes que caíram
 * juntos não reconectarem em lockstep. Base 0 (primeira conexão) permanece 0.
 */
export function applyReconnectJitter(delay: number, random: () => number = Math.random): number {
    return delay * (0.5 + random());
}
